import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { SOLUTIONS_CONSTANTS } from "./constants";

const Solutions = () => {
  return <CardsList {...SOLUTIONS_CONSTANTS} hoverEffect hover={LBGhoverEffect} />;
};

export default Solutions;
